import React from "react";
import classNames from "classnames";

import { ProgressBarProps } from "./types";

const ProgressBar = ({
  animateOnLoad,
  className,
  color,
  isOnDarkCanvas,
  size,
  squared,
  value,
  ...rest
}: ProgressBarProps) => {
  const progressBarClasses = classNames(
    "rds-ProgressBar",
    {
      "rds-ProgressBar--animateOnLoad": animateOnLoad,
      [`rds-ProgressBar--${color}`]: color !== "primary",
      "on-darkCanvas": isOnDarkCanvas,
      "rds-ProgressBar--squared": squared,
      [`rds-ProgressBar--${size}`]: size !== "medium",
    },
    className
  );

  return (
    <div
      {...rest}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      className={progressBarClasses}
    >
      <div
        style={{ width: `${value}%` }}
        className="rds-ProgressBar-value"
      ></div>
    </div>
  );
};

ProgressBar.displayName = "ProgressBar";

export default ProgressBar;
